import { render } from "./PageFooter.vue?vue&type=template&id=70640b3e&scoped=true"
const script = {}

import "./PageFooter.vue?vue&type=style&index=0&id=70640b3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70640b3e"]])

export default __exports__